import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import { Vuelidate } from 'vuelidate';
Vue.use(Vuelidate);
Vue.use(VueCookies);
Vue.config.productionTip = false
Vue.directive('clickOutside', {
    // 初始化指令
    bind(el, binding, vnode) {
        function clickHandler(e) {
            // 这里判断点击的元素是否是本身，是本身，则返回
            if (el.contains(e.target)) {
                return false;
            }
            // 判断指令中是否绑定了函数
            if (binding.expression) {
                // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
                if (Object.prototype.toString.call(binding.value) ===
                    '[object Function]') {
                    binding.value(e);
                }
            }
        }

        // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
        el.__vueClickOutside__ = clickHandler;
        document.addEventListener('click', clickHandler);
    },
    update() {
    },
    unbind(el, binding) {
        // 解除事件监听
        document.removeEventListener('click', el.__vueClickOutside__);
        delete el.__vueClickOutside__;
    }
});
//苹果文本框输入页面上滑问题
document.body.addEventListener('focusout', (event) => {
    if (document.documentElement.clientWidth >= 750) return;
    if (!!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        setTimeout(() => {
            const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
            window.scrollTo(0, Math.max(scrollHeight - 1, 0));
        }, 100);
    }
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
